import actions from './actions'

const booking = {
  state: {},
  mutations: {},
  actions
}

export default booking
